import React, { useEffect, useState } from "react";
import axios from "axios";
import BASE_URL from "../Config/apiConfig";
import { Link } from "react-router-dom";
import { FaHeart } from "react-icons/fa";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";


const ProductSlider = () => {
  const [products, setProducts] = useState([]);
  const [wishlist, setWishlist] = useState([]);

  // 👤 Get user
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?._id;

  // 🔑 Dynamic wishlist key
  const wishlistKey = userId ? `wishlist_${userId}` : null;

  // ⭐ Fetch Products
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/getAllProduct`);
        setProducts(res.data.result || []);
      } catch (err) {
        console.error("Product fetch error:", err);
      }
    };
    fetchProducts();
  }, []);

  // ❤️ Load Wishlist (user-wise)
  useEffect(() => {
    if (!wishlistKey) return;

    const data = JSON.parse(localStorage.getItem(wishlistKey)) || [];
    setWishlist(data);
  }, [wishlistKey]);

  // ❤️ Toggle Wishlist
  const toggleWishlist = (product) => {
    let updatedWishlist = [...wishlist];

    const index = updatedWishlist.findIndex(
      (item) => item._id === product._id
    );

    if (index > -1) {
      // ❌ Remove
      updatedWishlist.splice(index, 1);
    } else {
      // ✅ Add (clean object save)
      updatedWishlist.push({
        _id: product._id,
        pName: product.pName,
        pImg: product.pImg,
        price: product.price,
        description: product.description
      });
    }

    setWishlist(updatedWishlist);
    localStorage.setItem(wishlistKey, JSON.stringify(updatedWishlist));
  };

  // ⭐ Render Stars
  const renderStars = (ratestar) => {
    const rating = Math.round(Number(ratestar) * 2) / 2; // 👈 convert 4.3 → 4.5

    return [...Array(5)].map((_, index) => {
      const star = index + 1;

      if (rating >= star) {
        return <FaStar key={index} size={15} className="text-[#F9AE0E]" />;
      } else if (rating >= star - 0.5) {
        return <FaStarHalfAlt key={index} size={15} className="text-[#F9AE0E]" />;
      } else {
        return <FaRegStar key={index} size={15} className="text-gray-300" />;
      }
    });
  };

  return (
    <div className="py-14 bg-white">
      <div className="max-w-[1400px] mx-auto px-4">

        {/* TITLE */}
        <h2 className="text-center text-[26px] sm:text-[32px] lg:text-[38px] font-bold text-[#3A8DF5] mb-12">
          Our Featured Medicines
        </h2>

        {/* GRID */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
          {products.map((product) => {

            const reviews = product.review || [];
            const avgRating =
              reviews.length > 0
                ? Math.round(
                  reviews.reduce(
                    (sum, r) => sum + Number(r.rating || 0),
                    0
                  ) / reviews.length
                )
                : 0;

            const isWishlisted = wishlist.some(
              (item) => item._id === product._id
            );

            return (
              <div
                key={product._id}
                className="bg-white rounded-[28px] p-4 shadow-sm relative hover:shadow-md transition"
              >

                {/* ❤️ Wishlist */}
                <div
                  onClick={() => toggleWishlist(product)}
                  className="absolute top-4 right-4 cursor-pointer"
                >
                  <FaHeart
                    size={20}
                    className={
                      isWishlisted
                        ? "text-red-500"
                        : "text-gray-300"
                    }
                  />
                </div>

                {/* Image */}
                <Link to={`/product/${product._id}`} state={{ product }}>
                  <div className="bg-[#FAFAFA] rounded-[22px] h-[230px] flex items-center justify-center">
                    <img
                      src={`https://mediapi.onlinepharmaque.in/uploads/${product.pImg?.[0]}`}
                      alt={product.pName}
                      className="h-[190px] object-contain"
                    />
                  </div>
                </Link>

                {/* Name */}
                <p className="mt-4 text-[16px] font-semibold line-clamp-2">
                  {product.pName}
                </p>

                {/* Price */}
                <div className="inline-flex items-center gap-1 px-3 py-1 rounded-full border border-gray-300 bg-white shadow-sm">
                  <span className="text-sm font-medium text-gray-800">
                    {Number(product?.ratestar).toFixed(1)}
                  </span>
                  <FaStar className="text-[#F9AE0E] text-xs" />
                </div>

              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProductSlider;